interface Props {
  face: string
  points: readonly (readonly number[])[]
  detailed: boolean
  inkColor?: string
}

/** Lightweight vector markings, projected onto the same face as the carton. */
export default function CartonFaceDetails({ face, points, detailed, inkColor = '#805e39' }: Props) {
  const at = (u: number, v: number) => [
    points[0][0] + u * (points[1][0] - points[0][0]) + v * (points[3][0] - points[0][0]),
    points[0][1] + u * (points[1][1] - points[0][1]) + v * (points[3][1] - points[0][1]),
  ].join(',')
  const rectangle = (u: number, v: number, width: number, height: number) => `M${at(u, v)} L${at(u + width, v)} L${at(u + width, v + height)} L${at(u, v + height)}Z`
  const top = face === 'top'
  const end = face === 'left' || face === 'right'
  return <g aria-hidden="true" pointerEvents="none" data-material="cardboard">
    {top && <>
      <path d={rectangle(0, 0.445, 1, 0.11)} fill="#d9bd89" fillOpacity={0.85} stroke="#b18b50" strokeWidth={0.3} />
      <path d={`M${at(0, 0.5)} L${at(1, 0.5)}`} fill="none" stroke="#98703e" strokeWidth={0.55} opacity={0.7} />
      {detailed && <path d={`M${at(0.06, 0.04)} L${at(0.06, 0.445)} M${at(0.06, 0.555)} L${at(0.06, 0.96)} M${at(0.94, 0.04)} L${at(0.94, 0.445)} M${at(0.94, 0.555)} L${at(0.94, 0.96)}`} fill="none" stroke={inkColor} strokeWidth={0.4} opacity={0.28} />}
    </>}
    {end && <>
      <path d={rectangle(0.445, 0.67, 0.11, 0.33)} fill="#d9bd89" fillOpacity={0.85} stroke="#b18b50" strokeWidth={0.3} />
      <path d={`M${at(0.5, 0.67)} L${at(0.5, 1)}`} fill="none" stroke="#98703e" strokeWidth={0.45} opacity={0.6} />
    </>}
    {detailed && <>
      <path d={`M${at(0.05, 0.24)} L${at(0.3, 0.245)} M${at(0.63, 0.78)} L${at(0.9, 0.775)} M${at(0.1, 0.88)} L${at(0.35, 0.875)}`} fill="none" stroke={inkColor} strokeWidth={0.35} opacity={0.12} />
      {(face === 'front' || face === 'back') && <>
        <path d={rectangle(0.13, 0.4, 0.28, 0.33)} fill="#f6f1e5" stroke="#b49a73" strokeWidth={0.3} />
        <path d={`M${at(0.16, 0.66)} L${at(0.35, 0.66)} M${at(0.16, 0.61)} L${at(0.29, 0.61)}`} fill="none" stroke="#8d877a" strokeWidth={0.55} opacity={0.7} />
        <path d={[0.17, 0.19, 0.22, 0.235, 0.26, 0.29, 0.31, 0.335, 0.36].map(u => `M${at(u, 0.45)} L${at(u, 0.55)}`).join(' ')} fill="none" stroke="#625c50" strokeWidth={0.55} opacity={0.85} />
      </>}
    </>}
  </g>
}
